import { render } from "./custom_datatable.vue?vue&type=template&id=7b66c221&scoped=true"
import script from "./custom_datatable.vue?vue&type=script&lang=js"
export * from "./custom_datatable.vue?vue&type=script&lang=js"

import "./custom_datatable.vue?vue&type=style&index=0&id=7b66c221&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b66c221"]])

export default __exports__